/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProjectsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProjectsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { trashProjectsDirectoryRedirectRoute } from '@jira/router-routes__trash-projects-directory-routes/src/trashProjectsDirectoryRedirectRoute.tsx';
import RedirectToPrettyUrlTrashDirectory from './common/ui/redirect/jira-projects-trash-directory-redirect/index.tsx';
import { LazyTrashedProjectsAdmin } from './ui/admin-pages/trashed-projects/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const trashProjectsDirectoryRedirectRouteEntry: Route = createEntry(
	trashProjectsDirectoryRedirectRoute,

	() => ({
		group: 'global-settings',
		ufoName: 'admin.trashed-projects',
		// eslint-disable-next-line no-restricted-syntax
		component: RedirectToPrettyUrlTrashDirectory,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProjectsSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
		forPaint: [LazyAtlassianNavigation, LazyTrashedProjectsAdmin],
		isRedirect: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
